var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"node-overlay",style:(_vm.getItemStyle(_vm.item)),attrs:{"src":_vm.item.source,"alt":"..."}})
}
var staticRenderFns = []

export { render, staticRenderFns }